import { Roles } from "../enums";

import { T } from "./translation-keys";

export const RoleNames = {
  [Roles.SuperAdmin]: T.SUPER_ADMIN,
  [Roles.Admin]: T.ADMIN,
  [Roles.Partner]: T.PARTNER,
  [Roles.Manager]: T.MANAGER,
  [Roles.Cashier]: T.CASHIER,
};

export const RolesDropdownData = [
  // {
  //   value: Roles.SuperAdmin,
  //   label: RoleNames[Roles.SuperAdmin],
  // },
  // {
  //   value: Roles.Admin,
  //   label: RoleNames[Roles.Admin],
  // },
  {
    value: Roles.Partner,
    label: RoleNames[Roles.Partner],
  },
  {
    value: Roles.Manager,
    label: RoleNames[Roles.Manager],
  },
  {
    value: Roles.Cashier,
    label: RoleNames[Roles.Cashier],
  },
];